import ServiceActionTypes from './types'

const initialState = {
  service: {},
  serviceError: false,
}

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ServiceActionTypes.SET_SERVICE: {
      return { ...state, service: action.payload }
    }

    case ServiceActionTypes.SET_ERROR: {
      return { ...state, serviceError: action.payload }
    }

    default:
      return state
  }
}

export default serviceReducer
